import { render, staticRenderFns } from "./LayoutWizardConfig.vue?vue&type=template&id=985bf190"
import script from "./LayoutWizardConfig.js?vue&type=script&lang=js&external"
export * from "./LayoutWizardConfig.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports